// src/index.js
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/global.css';
import './index.css'; // Import the CSS file here

ReactDOM.render(<App />, document.getElementById('root'));

